module.exports = __webpack_public_path__ + "img/destinations-mauritius.d4ba7e65.webp";